// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'
import { gsap, Power4 } from "gsap/all";

export default class ContentComponent extends Component {
  
  constructor(element) {
    super(element);
    this.ref = {
      content: null,
    }
  }
  
  mount() {
    this.parallaxIn(this)
  }
  async unmount() {
    
    // await this.parallaxOut(this)
  }
  
  // parallaxOut() {
  //   gsap.to(this.ref.title, {
  //     color: 'red',
  //     duration: 0.1,
  //   });
  // }

  parallaxIn() {
    
    if (this.ref.content) {
        gsap.from(this.ref.content, {
            y: 200,
            duration: 1,
            delay: 1
          });
          gsap.from(this.ref.content, {
            opacity: 0,
            duration: 1.25,
            delay: 1
          });
    }
    
  }
  
  
}